// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2eDCj","label":"Section_label__2sIur","contentWrap":"Section_contentWrap__3nE2o","footer":"Section_footer__ycpxk","footerInner":"Section_footerInner__3p_x2"};